import { useMemo } from "react";
import { OnDatesChangeProps } from "@datepicker-react/hooks";
import Datepicker from "components/date-picker/datepicker";
const CalenderForMobile = ({
  onReset,
  onClose,
  startDate,
  endDate,
  minBookingDate,
  maxBookingDate,
  focusedInput,
  onDatesChange,
  vertical,
  initialVisibleMonth
}: {
  onReset: () => void;
  onClose: () => void;
  startDate: Date | null;
  endDate: Date | null;
  minBookingDate: Date | undefined;
  maxBookingDate: Date | undefined;
  focusedInput: "startDate" | "endDate" | null;
  onDatesChange: (newDates: OnDatesChangeProps) => void;
  vertical: boolean;
  initialVisibleMonth: Date;
}) => {
  const calendar = useMemo(() => {
    return <Datepicker isAnnotated={false} onReset={onReset} onClose={onClose} startDate={startDate} endDate={endDate} minBookingDate={minBookingDate} maxBookingDate={maxBookingDate} focusedInput={focusedInput} onDatesChange={onDatesChange} vertical={vertical} initialVisibleMonth={initialVisibleMonth} annotatedCalendarDates={undefined}
    // show all months [ which are included in booking range ] in mobile view calendar
    activeMonths={undefined} isPaddingRemove={true} />;
  }, [onReset, onClose, startDate, endDate, minBookingDate, maxBookingDate, focusedInput, onDatesChange, vertical, initialVisibleMonth]);
  return <div className='mobile-calendar' data-sentry-component="CalenderForMobile" data-sentry-source-file="CalenderForMobile.tsx">{calendar}</div>;
};
export default CalenderForMobile;